//jshint module : true
import payments from '../actions/payments-actions';

const initState = {
    bankIdVerification: {
        type: '',
        shouldInitBankID: false,
        bankIdInProgress: false,
        isAutoStartAllowed: false,
        autoStartToken: '',
        completeText: '',
        verificationText: '',
        bankIdErrorMessage: '',
        errorCount: 0,
        requireBankIdVerification: true
    },
    swishDetails: {
        newNumber: '',
        verifyCode: '',
        isValid: false,
        errorMessage: '',
        isCompany: false
    },
    bankAccountDetails: {
        newClearingNumber: '',
        newAccountNumber: '',
        bankAccountSaved: false,
        bankUnknown: false,
        errorMessage: '',
        hasFailedPayouts: false,
        isMemberSetForPayout: false
    },
    tink: {
        tinkOnboarding: false,
        iframeUrl: '',
        shouldInitTink: false,
        accounts: null,
        account: null,
        errorMessage: ''
    },
    payouts: [],
    pagination: {},
    paginationLinks: []
};

export default (state = initState, action) => {
    switch (action.type) {
        // Init
        case payments.actionTypes.INIT_DATA_LOADED:
            var swishApp2AppMember =
                action.payload.initData.pageSpecificData.swishApp2AppMember;
            var braintreeMember =
                action.payload.initData.pageSpecificData.braintreeMember;
            var onboardToHyperwalletProblems =
                action.payload.initData.pageSpecificData
                    .onboardToHyperwalletProblems;
            var isAutoStartAllowed =
                action.payload.initData.pageSpecificData.isAutoStartAllowed;
            var requireBankIdVerification =
                action.payload.initData.pageSpecificData
                    .requireBankIdVerification;
            var isCompany = action.payload.initData.pageSpecificData.isCompany;
            var tinkLink = action.payload.initData.pageSpecificData.tinkLink;
            var tinkOnboarding =
                action.payload.initData.featureSwitches['tink-onboarding'];
            var hyperwalletPayeeVerification =
                action.payload.initData.pageSpecificData
                    .hyperwalletPayeeVerification;
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    isAutoStartAllowed: isAutoStartAllowed,
                    requireBankIdVerification: requireBankIdVerification
                },
                swishDetails: {
                    ...state.swishDetails,
                    number: swishApp2AppMember.phoneNumber,
                    newNumber:
                        swishApp2AppMember.phoneNumber ||
                        swishApp2AppMember.suggestedPhoneNumber,
                    enabled: swishApp2AppMember.enabled,
                    state: swishApp2AppMember.state,
                    isCompany: isCompany,
                    checkMark:
                        swishApp2AppMember.state == 'Step3' ? 'Completed' : ''
                },
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    maskedBankAccountNumber:
                        braintreeMember.maskedBankAccountNumber,
                    isBankAccountSupplied:
                        braintreeMember.isBankAccountSupplied,
                    hasFailedPayouts: braintreeMember.hasFailedPayouts,
                    isMemberSetForPayout: braintreeMember.isMemberSetForPayout,
                    onboardToHyperwalletProblems: onboardToHyperwalletProblems,
                    checkMark:
                        !braintreeMember.hasFailedPayouts &&
                        braintreeMember.isBankAccountSupplied
                            ? 'Completed'
                            : ''
                },
                tink: {
                    ...state.tink,
                    tinkOnboarding: tinkOnboarding,
                    iframeUrl: tinkLink
                },
                hyperwalletPayeeVerification
            };
        // Swish
        case payments.actionTypes.SAVE_PHONENUMBER:
            return {
                ...state,
                swishDetails: {
                    ...state.swishDetails,
                    number: action.payload,
                    enabled: false,
                    verifyCode: '',
                    state: 'Step2',
                    checkMark: '',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.DELETE_PHONENUMBER:
            return {
                ...state,
                swishDetails: {
                    ...state.swishDetails,
                    enabled: false,
                    number: '',
                    verifyCode: '',
                    state: 'Step1',
                    checkMark: '',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.UPDATE_PHONENUMBER:
            return {
                ...state,
                swishDetails: {
                    ...state.swishDetails,
                    newNumber: action.payload.number,
                    checkMark: '',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.UPDATE_VERIFYCODE:
            return {
                ...state,
                swishDetails: {
                    ...state.swishDetails,
                    verifyCode: action.payload,
                    checkMark: '',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.SWISH_ENABLED:
            return {
                ...state,
                swishDetails: {
                    ...state.swishDetails,
                    enabled: true,
                    state: 'Step3',
                    checkMark: 'Completed',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.INVALID_PHONENUMBER:
        case payments.actionTypes.INVALID_VERIFYCODE:
        case payments.actionTypes.SWISH_ERROR:
            return {
                ...state,
                swishDetails: {
                    ...state.swishDetails,
                    errorMessage: action.payload
                }
            };
        // BankAccount
        case payments.actionTypes.UPDATE_CLEARING_NUMBER:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    newClearingNumber: action.payload.newClearingNumber,
                    checkMark: '',
                    bankUnknown: false,
                    errorMessage: ''
                }
            };
        case payments.actionTypes.UPDATE_ACCOUNT_NUMBER:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    newAccountNumber: action.payload.newAccountNumber,
                    checkMark: '',
                    bankUnknown: false,
                    errorMessage: ''
                }
            };
        case payments.actionTypes.DELETE_BANK_ACCOUNT:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    maskedBankAccountNumber: '',
                    isBankAccountSupplied: false,
                    newClearingNumber: '',
                    newAccountNumber: '',
                    checkMark: '',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.INVALID_CLEARINGNUMBER:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    errorMessage: action.payload
                }
            };
        case payments.actionTypes.INVALID_BANKACCOUNTNUMBER:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    errorMessage: action.payload
                }
            };
        case payments.actionTypes.BANK_ERROR:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    errorMessage: action.payload
                }
            };
        case payments.actionTypes.BANK_ACCOUNT_SAVED:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    bankAccountSaved: true,
                    isBankAccountSupplied: true,
                    maskedBankAccountNumber: action.payload,
                    checkMark: 'Completed',
                    errorMessage: ''
                }
            };
        case payments.actionTypes.BANK_NOT_MATCHED:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    bankUnknown: true
                }
            };
        case payments.actionTypes.IGNORE_BANK_NOT_MATCHED:
            return {
                ...state,
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    bankUnknown: false
                }
            };
        // Tink
        case payments.actionTypes.INIT_TINK:
            return {
                ...state,
                tink: {
                    ...state.tink,
                    shouldInitTink: true,
                    errorMessage: ''
                }
            };
        case payments.actionTypes.CANCEL_TINK:
            return {
                ...state,
                tink: {
                    ...state.tink,
                    shouldInitTink: false,
                    accounts: null
                }
            };
        case payments.actionTypes.SHOW_BANK_ACCOUNTS:
            return {
                ...state,
                tink: {
                    ...state.tink,
                    accounts: action.payload
                }
            };
        case payments.actionTypes.SELECT_BANK_ACCOUNT:
            return {
                ...state,
                tink: {
                    ...state.tink,
                    account: action.payload
                }
            };
        case payments.actionTypes.TINK_COMPLETED:
            return {
                ...state,
                tink: {
                    ...state.tink,
                    shouldInitTink: false,
                    accounts: null
                },
                bankAccountDetails: {
                    ...state.bankAccountDetails,
                    bankAccountSaved: true,
                    isBankAccountSupplied: true,
                    maskedBankAccountNumber: action.payload,
                    checkMark: 'Completed'
                }
            };
        case payments.actionTypes.TINK_ERROR:
            return {
                ...state,
                tink: {
                    ...state.tink,
                    errorMessage: action.payload
                }
            };
        // BankId
        case payments.actionTypes.SKIP_BANKID_AUTH:
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    type: action.payload.type,
                    shouldInitBankID: false,
                    bankIdCompleted: true,
                    completeText: action.payload.completeText,
                    verificationText: action.payload.verificationText,
                    bankIdErrorMessage: '',
                    requireBankIdVerification: false
                }
            };
        case payments.actionTypes.BEGIN_BANKID_AUTH:
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    type: action.payload.type,
                    shouldInitBankID: true,
                    bankIdCompleted: false,
                    completeText: action.payload.completeText,
                    verificationText: action.payload.verificationText,
                    bankIdErrorMessage: ''
                }
            };
        case payments.actionTypes.CANCEL_BANKID_AUTH:
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    type: '',
                    shouldInitBankID: false,
                    bankIdInProgress: false,
                    bankIdCompleted: false,
                    bankIdErrorMessage: ''
                }
            };
        case payments.actionTypes.BANKID_IN_PROGRESS:
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    bankIdInProgress: true,
                    autoStartToken: action.payload.autoStartToken
                }
            };
        case payments.actionTypes.BANKID_ERROR:
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    bankIdErrorMessage: action.payload,
                    bankIdInProgress: false,
                    bankIdCompleted: false
                }
            };
        case payments.actionTypes.BANKID_COMPLETED:
            return {
                ...state,
                bankIdVerification: {
                    ...state.bankIdVerification,
                    shouldInitBankID: false,
                    bankIdInProgress: false,
                    bankIdCompleted: true
                }
            };
        // Payouts
        case payments.actionTypes.PAYOUTS_LOADED:
            return {
                ...state,
                payouts: action.payload.list,
                pagination: action.payload.pagination,
                paginationLinks: action.payload.paginationLinks
            };
        case payments.actionTypes.PAYOUTS_ERROR:
            return {
                ...state
            };
        // Default
        default:
            return state;
    }
};

export const selectPaymentsState = state => state.views.myTradera.payments;
